import { ResidentData } from '@/models'
import { Building } from '@/reducers/types'

export const getResidentUnitDisplay = (
  data: ResidentData | undefined | null,
  selectedBuilding: Building | null,
): string => {
  if (!data) return ''

  const buildingNumber = data.buildingNumber ?? data.residentBuildingNumber ?? ''
  const unit = data.residentUnit ?? data.apartment ?? ''

  if (selectedBuilding?.displayBuildingNumber && buildingNumber && unit) {
    return `${buildingNumber} - ${unit}`
  }

  return unit
}
